import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import MainCard from "../../../Components/Cards/MainCard";
import QuickActionsSkeleton from "../../../Components/Skeleton/QuickActionsSkeleton";
import { Link } from "react-router-dom";

const QuickActions = () => {
  const [actions, setActions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setActions([
        {
          title: "Review Applications",
          subtitle: "5 pending",
          active: true,
          link: "/applications",
        },
        {
          title: "Process Payments",
          subtitle: "3 pending",
          active: false,
          link: "/payments",
        },
        {
          title: "Publish Content",
          subtitle: "2 drafts",
          active: false,
          link: "/content",
        },
      ]);
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <MainCard>
      {/* Header */}
      <Card.Header className="fw-bold rounded-3 bg-white border-0 mb-3 fs-4">
        Quick Actions
      </Card.Header>

      {/* Content */}
      {loading ? (
        <QuickActionsSkeleton />
      ) : actions && actions.length > 0 ? (
        <div className="d-flex gap-3">
          {actions.map((action, idx) => {
            const Wrapper = action.link ? Link : "div";
            return (
              <Wrapper
                key={idx}
                to={action.link || "#"}
                className={`flex-fill text-center py-3 px-2  rounded-4 ${
                  action.active
                    ? "bg-primary text-white"
                    : "border bg-white text-dark"
                }`}
                style={{ cursor: "pointer", textDecoration: "none" }}
              >
                <div className="fw-bold">{action.title}</div>
                <small
                  className={`${
                    action.active ? "text-white-50" : "text-muted"
                  }`}
                >
                  {action.subtitle}
                </small>
              </Wrapper>
            );
          })}
        </div>
      ) : (
        <div className="text-center text-muted py-4">No quick actions</div>
      )}
    </MainCard>
  );
};

export default QuickActions;
